<div class="race-container">
  <h2>Prijavnica</h2>
  <p>Prijavite se lahko na vse tri teke.</p>

  <form [formGroup]="raceForm" (ngSubmit)="onSubmit()">
    <div class="checkbox-group">
      <label>
        Šolska mladina 250m - 2000m
        <input type="checkbox" formControlName="kids" />
      </label>
      <label>
        Rekreativni tek 4,8 km
        <input type="checkbox" formControlName="shortRace" />
      </label>
      <label>
        Člani 11,8 km
        <input type="checkbox" formControlName="longRace" />
      </label>
    </div>

    <div class="form-row">
      <div class="form-column">
        <label for="name">Ime:</label>
        <input id="name" type="text" formControlName="name" required />
        
        <label for="email">Email:</label>
        <input id="email" type="email" formControlName="email" required />
        <label for="yearOfBirth">Leto rojstva:</label>
        <input id="yearOfBirth" type="number" formControlName="yearOfBirth" required min="1920" />
        <label for="sex">Spol:</label>
        <select id="sex" formControlName="sex">
          <option value="Moški">Moški</option>
          <option value="Ženska">Ženska</option>
          <option value="Ostalo">Ostalo</option>
        </select>

      </div>
      
      <div class="form-column">
                
        <label for="address">Naslov:</label>
        <input id="address" type="text" formControlName="address" required />

        <label for="club">Klub:</label>
        <input id="club" type="text" formControlName="club" />
        
        <label for="citizenship">Državljanstvo:</label>
        <input id="citizenship" type="text" formControlName="citizenship" required />
        
        <div *ngIf="raceForm.get('kids')!.value">
          <label for="kidsLength">Dolžina proge (Označi ob prijavi na tek šolske mladine):</label>
          <select id="kidsLength" formControlName="kidsLength" required>
            <option value="250">Cicitek 250m</option>
            <option value="300">300m</option>
            <option value="600">600m</option>
            <option value="1000">1000m</option>
            <option value="2000">2000m</option>
          </select>
        </div>
      </div>
    </div>
    
    <button type="submit" [disabled]="!raceForm.valid">Pošlji prijavo</button>
  </form>
</div>
<!-- Table of Racers -->
<div *ngIf="isOrgAdmin" class="container table mt-5">
    <h3>Seznam tekačev</h3>
    <p>Število prijavljenih: {{ racers.length }}</p>
  
    <!-- Scrollable container -->
    <div style="overflow-x: auto; width: 100%;">
      <table *ngIf="racers.length > 0" border="1" cellpadding="10" cellspacing="0" style="width: 100%; margin-top: 20px; white-space: nowrap;">
        <thead>
          <tr>
            <th>Ime</th>
            <th>Email</th>
            <th>Leto rojstva</th>
            <th>Spol</th>
            <th>Klub</th>
            <th>Državljanstvo</th>
            <th>Šolska mladina</th>
            <th>Dolžina proge otroka</th>
            <th>Rekreativni tek</th>
            <th>Člani</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let racer of racers">
            <td>{{ racer.name }}</td>
            <td>{{ racer.email }}</td>
            <td>{{ racer.yearOfBirth }}</td>
            <td>{{ racer.sex }}</td>
            <td>{{ racer.club }}</td>
            <td>{{ racer.citizenship }}</td>
            <td>{{ racer.kids ? 'Da' : 'Ne' }}</td>
            <td>{{ racer.kidsLength ? racer.kidsLength + 'm' : 'N/A' }}</td>
            <td>{{ racer.shortRace ? 'Da' : 'Ne' }}</td>
            <td>{{ racer.longRace ? 'Da' : 'Ne' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <p *ngIf="racers.length === 0">Ni še registriranih tekmovalcev.</p>
    <!-- Add the download button -->
    <button (click)="downloadCSV()">Naloži CSV</button>
  </div>
